import React from "react";
import { Form, InputNumber, Select } from "antd";
import { APARTMENT_INSURANCE_OPTIONS } from "../../../constants";

export default function CompareSection() {
  return (
    <>
      <Form.Item label="Зээлийн жилийн хүү (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minAnnualInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxAnnualInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Зээлийн бодит өртөг (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minEffectiveInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxEffectiveInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item name="downPaymentRate" label="Урьдчилгаа төлбөр доод (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="30"
        />
      </Form.Item>

      <Form.Item name="serviceFeeRate" label="Зээлийн үйлчилгээний шимтгэл (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="1.0"
        />
      </Form.Item>

      <Form.Item name="debtToIncomeRatio" label="Өр орлогын харьцаа дээд (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="60"
        />
      </Form.Item>

      <Form.Item
        name="creditBureauFee"
        label="Зээлийн мэдээллийн сангийн лавлагаа (₮)"
      >
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="1,000"
        />
      </Form.Item>

      <Form.Item name="loanApplicationFee" label="Өргөдөл судалсны хураамж (₮)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="5,000"
        />
      </Form.Item>

      <Form.Item name="collateralRatio" label="Зээл барьцааны харьцаа (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="80"
        />
      </Form.Item>

      <Form.Item name="termChangeFee" label="Нөхцөл өөрчилсний шимтгэл (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="0"
        />
      </Form.Item>

      <Form.Item name="insuranceTypes" label="Даатгал">
        <Select
          mode="multiple"
          allowClear
          placeholder="Сонгох"
          options={APARTMENT_INSURANCE_OPTIONS}
        />
      </Form.Item>
    </>
  );
}
